import { Text } from "@mantine/core";

interface FlightListInfoProps {
  isDarkTheme: boolean
}

export const FlightListInfo = (props:FlightListInfoProps) => {
    return (
      <Text color={props.isDarkTheme ? 'white' : 'black'} style={{display:'block', margin:'20px auto', padding:'10px', listStyleType:'decimal'}}>
        <strong>To change the TOBT of a flight</strong>
        <li>
          Enter part or all of the flight ID in the Search field
        </li>
        <li>
          Select a flight from the list
        </li>
        <li>
          Set the TOBT
        </li>
      </Text>
    );
}
